<template>
  <div class="card">
    <div class="createDocument">
      <button class="btn" v-on:click="onOpenCreateDocument">Создать Накладной</button>
    </div>
    <div class="search form-control">
      <input placeholder="Поиск..." v-on:input="onSearchDocument($event)"/>
    </div>
    <Pagination :page="pageRequest.page" :totalPages="totalPages" @move="onMove"/>
    <ul class="list">
      <div class="headers">
        <div class="header">Название</div>
        <div class="header">Код Клиента</div>
        <div class="header">Дата создание</div>
      </div>
      <li
          class="list-item"
          v-for="(document, idx) in listDocuments.list"
          v-bind:key="idx"
          v-on:click="onViewItem(document)"
      >
        <span class="body-item">{{document.label}}</span>
        <span class="body-item">{{document.client.code}}</span>
        <span class="body-item">{{document.createdAt}}</span>
      </li>
    </ul>
  </div>
</template>

<script>

import { Options, Vue } from 'vue-class-component';
import Pagination from '@/components/Pagination.vue';

@Options({
  name: "ListDocuments",
  components: {
    Pagination
  },
  mounted() {
    const {dispatch} = this.$store;
    dispatch('getListDocuments', {pageRequest: this.pageRequest, searchString: this.searchString})
  },
  data() {
    return {
      searchString: null,
      pageRequest: {
        limit: 10,
        page: 1
      }
    }
  },
  methods: {
    onOpenCreateDocument() {
      this.$router.push(`/documents/create`);
    },
    onViewItem(document) {
      this.$router.push(`/documents/${document.id}`);
    },
    onMove(page) {
      this.pageRequest.page = page
      const {dispatch} = this.$store;
      dispatch('getListDocuments', {pageRequest: this.pageRequest, searchString: this.searchString})
    },
    onSearchDocument(event) {
      const {dispatch} = this.$store;
      const {value} = event.target;
      this.searchString = value;
      if (this.searchString !== null && (this.searchString.length >= 3 || this.searchString.length === 0)) {
        dispatch('getListDocuments', {pageRequest: this.pageRequest, searchString: this.searchString})
      }
    }
  },
  computed: {
    listDocuments() {
      const {state} = this.$store;
      return state.documentModule.listDocuments
    },
    totalPages() {
      return Math.ceil(this.listDocuments.totalCount / this.pageRequest.limit);
    }
  }
})
export default class ListDocuments extends Vue {}
</script>

<style lang="scss">
@import "src/assets/scss/theme";
.card {
  height: 100vh;
}
.createDocument {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
.search {
  input {
    border-radius: 6px;
  }
}
.headers {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid $border-color;
  padding: 5px;
  border-radius: 4px;
  .header {
    display: flex;
    justify-self: start;
    width: 33.3%;
    font-weight: 600;
  }
}
.list-item {
  display: flex;
  border-bottom: 1px solid;
  border-right: 1px solid;
  border-left: 1px solid;
  border-color: $border-color;
  padding: 5px;
  &:hover {
    color: #fff;
    background: #2c3e50;
    cursor: pointer;
  }
  .body-item {
    display: flex;
    justify-self: start;
    width: 33.3%;
    padding-left: 3px;
  }
}
</style>